import { AdminAttributes } from "./admin.model";
import { SupportMessage } from "./support-chat.model";

export enum SupportSessionStatus {
    Queued = "QUEUED",
    Active = "ACTIVE",
    Closed = "CLOSED",
    Cancelled = "CANCELLED",
}

export interface BaseSupportSession {
    adminId?: number;
    userDisplayName?: string | null;
    contactEmail?: string | null;
    contactPhone?: string | null;
    topic?: string | null;
    isUserNewMessageViewed: boolean;
    metadata?: Record<string, unknown>;
    publicId?: string;
    status?: SupportSessionStatus;
    queuePosition?: number | null;
    startedAt?: Date | null;
    endedAt?: Date | null;
    senderId?: number;
}

export interface SupportSessionAttributes extends BaseSupportSession {
    id: number;
    createdAt?: Date;
    updatedAt?: Date;
    admin?: AdminAttributes;
    messages?: SupportMessage[];
}

export interface UserStartPayload {
    displayName?: string;
    contactEmail?: string;
    contactPhone?: string;
    topic?: string;
    aiHistory?: string;
    senderId?: number;
}

export interface SessionRequestInput extends BaseSupportSession {
    ipAddress?: string | null;
    aiHistory?: string | null;
}

export interface SessionRequestResult {
    session: SupportSessionAttributes;
    wasQueued: boolean;
}

export interface SpecialistReadyPayload {
    adminId: number;
    sessionPublicId: string;
}

export interface MessagePayload {
    sessionPublicId: string;
    senderId: number;
    body: string;
}
